import ArrowUp from "@/Icons/ArrowUp";
import InfoPopup from "@/components/InfoPopup/InfoPopup";
import { TableHeaderInterface } from "@/pages/CustomerDetails/customerDetails.interface";
import { useTrans } from "@/translations";

import React from "react";

import { twMerge } from "tailwind-merge";

export const TableHeader: React.FC<TableHeaderInterface> = ({
  field,
  label,
  activeField,
  setSort,
  direction,
  className,
  tooltipText,
  tooltipComponent,
}) => {
  const { t } = useTrans();
  const isActive = activeField === field;
  return (
    <div
      className={twMerge(
        "flex w-full items-center pl-3 text-start text-sm font-medium text-black",
        setSort && "cursor-pointer",
        className,
      )}
      onClick={() => setSort && setSort(field)}
    >
      {t(label)}
      {setSort && (
        <ArrowUp
          className={twMerge(
            "ml-2",
            isActive ? "text-black" : "text-grey4",
            isActive && direction !== "desc" && "rotate-180",
          )}
        />
      )}
      {tooltipText && (
        <InfoPopup
          text={t(tooltipText)}
          id={label}
          size={14}
          width="250px"
          className="mb-1 ml-1"
        />
      )}
      {!tooltipText && tooltipComponent && (
        <InfoPopup id={label} size={14} width="250px" className="mb-1 ml-1">
          {tooltipComponent}
        </InfoPopup>
      )}
    </div>
  );
};

export default TableHeader;
